import Services, { handleError } from "./index.service";
const { OshimedBackend } = Services;


/**
 * Récupère les détails patient via URL chiffrée
 * @param {string} encrypted - Contenu chiffré dans l’URL
 * @param {string} token - Jeton de session
 * @returns {Promise<object>} Données patient ou erreur
 */
const fetchQrScanDetailsViaUrl = async (participantId, token) => {
  try {
    const res = await OshimedBackend.get(`/qr-code/access?participant_id=${encodeURIComponent(participantId)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return handleError(err, "qr-scan-url-failed", 842012);
  }
};

/**
 * Génère une URL d'accès sécurisée pour un participant
 * @param {object} payload - Contient uniquement { id }
 * @param {string} token - Jeton de session
 * @returns {Promise<object>} Lien d’accès ou erreur
 */
const generateQrCode = async (payload, token) => {
  try {
    const res = await OshimedBackend.post("/qr-code/generate", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (err) {
    return handleError(err, "qr-generation-failed", 842011);
  }
};

const QrService = {
  fetchQrScanDetailsViaUrl,
  generateQrCode,
};

export default QrService;